import React from 'react';
import CurrentAccout from 'components/Tvendo/Bank/DataMaster/Payments/CurrentAccout/List.js';

export default function () {
  return <CurrentAccout />;
}
